import './style.css';
import runGame from './components/game/main';

const isMobile = () => window.matchMedia('(any-hover:none)').matches;

const wantsDashboard = () => {
    const params = new URLSearchParams(window.location.search);
    const path = window.location.pathname;
    return params.get('view') === 'data' || path.startsWith('/data') || path.startsWith('/dashboard') || path.startsWith('/vote') || path.startsWith('/contest');
};

(async () => {
    if (isMobile() || wantsDashboard()) {
        // Render the React dashboard and exit early
        const { renderMobileApp } = await import('./components/MobileApp/main');
        renderMobileApp();
        return;
    }

    runGame();
})();